import {Stat} from './stat';
import {Offer} from '../offer';

export class TopOffer extends Stat {
  offer: Offer | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    return this;
  }

  override toString(): string {
    return this.offer?.name ?? '';
  }
}
